export default "__VITE_ASSET__b5358812__"